<template>
  <v-container fluid class="purchaseorder-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab :href="`#tab-purchaseorder`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Order
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-transaction`">
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab :href="`#tab-files`" class="mr-5">
            <v-icon class="mr-3">mdi-file-pdf-box</v-icon>
            Files
          </v-tab>
          <v-tab-item :value="'tab-purchaseorder'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Purchase Order</p>
                      <v-select
                        :readonly="!isEditable"
                        class="mb-4"
                        :items="purchaseordertype"
                        v-on:change="onChangeOrder($event, 'purchaseordertype')"
                        v-bind:value="edit_purchaseorder.purchaseordertype"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the sales order type"
                      >
                      </v-select>
                      <v-menu
                        ref="menu_purchaseorderdate"
                        v-model="menu_purchaseorderdate"
                        :close-on-content-click="false"
                        :return-value.sync="purchaseorderdate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :readonly="!isEditable"
                            class="mb-4"
                            outlined
                            dense
                            v-model="edit_purchaseorder.purchaseorderdate"
                            label="Purchase Order Date"
                            v-bind="attrs"
                            v-bind:value="edit_purchaseorder.purchaseorderdate"
                            v-on:change="onChangeOrder($event, 'purchaseorderdate')"
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            persistent-hint
                            hint="Please choose the sales order type"
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          v-model="edit_purchaseorder.purchaseorderdate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_purchaseorderdate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="
                              onChangeOrder(
                                purchaseorderdate,
                                'purchaseorderdate'
                              );
                              $refs.menu_purchaseorderdate.save(edit_purchaseorder.purchaseorderdate);
                            "
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                      <v-select
                        class="mb-4"
                        :items="['New', 'Partial', 'Pending', 'Completed']"
                        v-on:change="onChangeOrder($event, 'purchaseorderstatus')"
                        v-bind:value="edit_purchaseorder.purchaseorderstatus"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line
                        hint="Please choose the order status"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        :readonly="!isEditable"
                        class="mb-4"
                        :items="
                          vendors.filter(vendor=>vendor.vendortype=='Supplier').map((x) => {
                            return { text: x.vendorname, value: x._id };
                          })
                        "
                        v-model="edit_purchaseorder.vendorid"
                        v-bind:error="errorindex == 2"
                        v-on:change="selectVendor($event); onChangeOrder($event, 'vendorid');"
                        outlined
                        dense
                        placeholder="Vendor"
                        persistent-hint
                        single-line
                        hint="Please choose the vendor"
                      >
                      </v-select>
                      <v-text-field
                        :readonly="!isEditable"
                        outlined
                        dense
                        class="mb-4"
                        v-model="edit_purchaseorder.purchaseordername"
                        v-on:change="
                          onChangeOrder($event, 'purchaseordername')
                        "
                        v-bind:error="errorindex == 10"
                        placeholder="Vendor Name"
                        persistent-hint
                        single-line
                        hint="Enter the Vendor Name"
                      >
                      </v-text-field>
                      <v-textarea
                        :readonly="!isEditable"
                        outlined
                        v-model="edit_purchaseorder.purchaseorderaddress"
                        v-on:change="
                          onChangeOrder($event, 'purchaseorderaddress')
                        "
                        rows="2"
                        label="Address"
                        hint="please enter the vendor address"
                      ></v-textarea>
                      <v-text-field
                        :readonly="!isEditable"
                        class="mb-4"
                        v-model="edit_purchaseorder.purchaseorderphone"
                        v-on:change="
                          onChangeOrder($event, 'purchaseorderphone')
                        "
                        outlined
                        v-bind:error="errorindex == 11"
                        dense
                        placeholder="Phone"
                        persistent-hint
                        single-line
                        hint="Enter the phone"
                      >
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        :readonly="!isEditable"
                        class="mb-4"
                        :items="locations.map((x) => {return { text: x.locationname, value: x._id };})"
                        v-bind:value="edit_purchaseorder.locationid"
                        v-on:change="onChangeOrder($event, 'locationid')"
                        v-bind:error="errorindex == 3"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line
                        hint="Please choose the location"
                      >
                      </v-select>
                      <v-select
                        :readonly="!isEditable"
                        class="mb-4"
                        :items="countries.map((x) => {return { text: x.countryname, value: x._id };})"
                        v-bind:value="edit_purchaseorder.countryid"
                        v-on:change="onChangeOrder($event, 'countryid')"
                        v-bind:error="errorindex == 4"
                        outlined
                        dense
                        placeholder="Country"
                        persistent-hint
                        single-line
                        hint="Please choose the country"
                      >
                      </v-select>
                      <v-select
                        :readonly="!isEditable"
                        class="mb-4"
                        :items="purchaseorderpayterms"
                        v-bind:value="edit_purchaseorder.purchaseorderpayterms"
                        v-on:change="onChangeOrder($event, 'purchaseorderpayterms')"
                        v-bind:error="errorindex == 5"
                        outlined
                        dense
                        placeholder="Pay Terms"
                        persistent-hint
                        single-line
                        hint="Please choose the pay terms"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        class="mb-4"
                        v-bind:value="edit_purchaseorder.refnum"
                        v-on:change="onChangeOrder($event, 'refnum')"
                        outlined
                        dense
                        placeholder="Ref Num"
                        persistent-hint
                        single-line hint="Enter reference or description">
                      </v-text-field>
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-select
                            class="mb-4"
                            :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                            v-bind:value="edit_purchaseorder.primaryCurrency"
                            v-on:change="onChangeOrder($event, 'primaryCurrency')"
                            outlined
                            dense
                            placeholder="Currency 1"
                            persistent-hint
                            single-line hint="Currency 1">
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-select
                            class="mb-4"
                            :items="['USD', 'SGD', 'MMK', 'THB', 'KHR']"
                            v-bind:value="edit_purchaseorder.secondaryCurrency"
                            v-on:change="onChangeOrder($event, 'secondaryCurrency')"
                            outlined
                            dense
                            placeholder="Currency 2"
                            persistent-hint
                            single-line hint="Currency 2">
                          </v-select>
                        </v-col>
                      </v-row>
                      <v-text-field
                        class="mb-4"
                        v-bind:value="edit_purchaseorder.currencyRate"
                        v-on:change="onChangeOrder($event, 'currencyRate')"
                        :v-bind:value="1"
                        outlined
                        dense
                        placeholder="Rate"
                        persistent-hint
                        single-line hint="Enter the currency rate">
                      </v-text-field>
                      <v-textarea
                        v-bind:value="edit_purchaseorder.purchaseordernote"
                        v-on:change="onChangeOrder($event, 'purchaseordernote')"
                        outlined
                        dense
                        rows=1
                        label="Note"
                        hint="please enter the note"
                      ></v-textarea>
                    </v-form>
                  </v-col>       
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/purchaseorder/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="updatePurchaseOrder()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-transaction'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <p class="text-h5">Items</p>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="6" class="d-flex flex-end justify-md-end overflow-auto" align="right">
                    <v-btn
                      v-show="isEditable"
                      class="button-shadow mr-1"
                      color="success"
                      @click="isAddTransaction=true; new_transaction={}">
                      Add
                    </v-btn>
                    <v-btn
                      class="button-shadow mr-1"
                        to="/purchaseorder/list"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                  </v-col>
                </v-row>
                <v-data-table
                  :headers="header_item"
                  :items="transactions"
                  :items-per-page="100"
                  class="elevation-0"
                >
                  <template v-slot:top>
                    <v-dialog v-model="isDeleteTransaction" width="500">
                      <v-card>
                        <v-card-title>Delete this Item? </v-card-title>
                        <v-card-text>
                          {{ deletetransaction.itemname }}
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            color="primary"
                            outlined
                            @click="isDeleteTransaction = false"
                          >Cancel</v-btn>
                          <v-btn
                            color="secondary"
                            class="button-shadow"
                            @click="deleteTransaction(deletetransaction)"
                          >Delete</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                  <template v-slot:item.itemname="{ item }">
                    <p class="two-line" style="font-size: 10pt; font-weight: 500;">{{ item.itemname }}</p>
                    <p class="two-line" style="font-size: 10pt;">{{ item.itemdesc }}</p>
                  </template>
                  <template v-slot:item.itemprice="{ item }">
                    {{ item.itemprice!=null ? item.itemprice.toFixed(2) : 0 }}
                  </template>
                  <template v-slot:item.itemamount="{ item }">
                    {{ item.itemamount!=null ? item.itemamount.toFixed(2) : 0 }}
                  </template>
                  <template v-slot:item.itemimage="{ item }">
                    <v-img
                      v-bind:lazy-src="item.itemimage"
                      min-width="50"
                      max-width="100"
                      v-bind:src="item.itemimage"
                    ></v-img>
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      icon
                      color="primary"
                      @click="updateTransactionDialog(item)"
                    >
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>
                    <v-btn
                      icon
                      color="primary"
                      @click="deleteTransactionDialog(item)"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-files'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                        <v-col md="11">
                          <p class="text-h5">Files</p>
                        </v-col>
                        <v-col md="1">
                          <v-btn
                            class="button-shadow"
                            color="secondary"
                            @click="isUploadFile = true"
                          >
                            Add
                          </v-btn>
                        </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        :headers="header_file"
                        :items="files"
                        :items-per-page="100"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteFile" width="500">
                            <v-card>
                              <v-card-title> Delete this File? </v-card-title>
                              <v-card-text>
                                {{ deletefile.filename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteFile = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteFile(deletefile)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.filetype="{ item }">
                            <a v-if="item.filetype=='pdf'" :href="item.fileurl" style="text-decoration: none !important;">
                              <v-icon 
                            size="50"
                            color="primary"
                            >
                              mdi-file-pdf-box
                            </v-icon></a>    
                        </template>
                        <template v-slot:item.filesize="{ item }">
                            {{ (item.filesize/1000).toFixed(0) + " KB"  }}    
                        </template>
                        <template v-slot:item.createdAt="{ item }">
                          {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' })  }}
                        </template>
                        <template v-slot:item.actions="{ item }">

                          <v-btn
                            icon
                            color="primary"
                            @click="deleteFileDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>

                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/purchaseorder/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-dialog
        v-model="isAddTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Item</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items=branditems
                    v-model="add_transaction.itemid"
                    v-bind:error="errorindex == 22"
                    outlined
                    dense
                    placeholder="Item"
                    persistent-hint
                    single-line hint="Item">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="add_transaction.itemquantity"
                    v-bind:error="errorindex == 23"
                    v-on:input="calculateAmount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Qty"
                    persistent-hint
                    type="number"
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="Quantity">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="add_transaction.itemprice"
                    v-bind:error="errorindex == 24"
                    v-on:input="calculateAmount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Cost"
                    type="number"
                    persistent-hint
                    single-line hint="Cost">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    v-bind:value="add_transaction.itemamount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isAddTransaction=false; add_transaction={};"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="insertTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Item</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items="items.map(x => {
                      return {text: x.itemname, value: x._id};
                      })"
                    v-model="edit_transaction.itemid"
                    dense
                    placeholder="Item"
                    persistent-hint
                    single-line hint="Item">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    v-model="edit_transaction.itemdesc"
                    class="mb-4"
                    dense
                    placeholder="Description"
                    persistent-hint
                    single-line hint="Description">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_transaction.itemquantity"
                    class="mb-4"
                    dense
                    placeholder="Qty"
                    persistent-hint
                    type="number"
                    v-on:input="onChangePriceEdit"
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="Quantity">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.itemprice"
                    class="mb-4"
                    dense
                    placeholder="Prc"
                    v-on:input="onChangePriceEdit"
                    persistent-hint
                    single-line hint="Price">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    v-model="edit_transaction.itemamount"
                    class="mb-4"
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={};"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isUploadFile"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Upload File</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                <v-file-input label="File input" v-on:change="onFileChange" accept=".pdf" />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="upload.filename"
                    label="File Name"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isUploadFile = false; upload.file=null; upload.filename=''"
            >
              Close
            </v-btn>
            <v-btn
              :disabled="upload.file == null || upload.filename.length<2"
              color="blue darken-1"
              text
              @click="uploadFile"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';
import router from "@/Routes";

export default {
  data() {
    return {
      purchaseorderdate: null,
      menu_purchaseorderdate: false,

      upload: {filename: null, file: null},
      header_item: [
        { text: 'Image', value: 'itemimage', width: '10%' },
        { text: 'Name', value: 'itemname' },
        { text: 'Qty', value: 'itemquantity', width: '5%'},
        { text: '', value: 'unit', width: '5%' },
        { text: 'Prc', value: 'itemprice', width: '10%'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],
      header_file: [
        { text: "Type", value: "filetype" },
        { text: "Name", value: "filename" },
        { text: "Size", value: "filesize" },
        { text: "Created", value: "createdAt" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      files: [],
      
      transactions: [],
      purchaseordertype: ["Purchase Order", "Purchase Invoice"],
      purchaseorderpayterms: ["Due on Receipt", "Credit 15 Days", "Credit 30 Days"],
      
      
      brandid: undefined,
      branditems:[],

      price: undefined,
      
      initvalue: {},
      add_transaction: {},
      change_purchaseorder: {},
      change_transaction: {},
      edit_purchaseorder: {},
      edit_transaction: {},
      
      deletetransaction: {},
      deletefile: {},
      purchaseorder: {},

      imageurl: undefined,
      error: undefined,
      errorindex: undefined,

      isAddTransaction: false,
      isEditTransaction: false,
      isDeleteTransaction: false,
      isDeleteFile: false,
      isUploadFile: false,
      
      


    };
  },
  computed: {
    ...mapState("Brand", ["brands"]),
    ...mapState("Country", ["countries"]),
    ...mapState("Vendor", ["vendors"]),
    ...mapState("Item", ["items"]),
    ...mapState("Price", ["prices"]),
    ...mapState("PriceList", ["pricelists"]),
    ...mapState("Location", ["locations"]),
    ...mapState("PurchaseOrder", ["isReceiving"]),
    isEditable(){
      let result = ['New','Partial','Pending','Audit','Void'].indexOf(this.initvalue.purchaseorderstatus) >= 0;
      return result;
    },
  },
  methods: {
    ...mapActions("Brand", ["getBrandsRequest"]),
    ...mapActions("Country", ["getCountriesRequest"]),
    ...mapActions("Vendor", ["getVendorsRequest"]),
    ...mapActions("File", ["insertRouteFile", "deleteFileRequest", "getPurchaseOrderFiles"]),
    ...mapActions("Item", ["getItemsRequest"]),
    ...mapActions("Price", ["getPricesRequest"]),
    ...mapActions("PriceList", ["getPriceListsRequest"]),
    ...mapActions("PurchaseOrder", ["getPurchaseOrderRequest", "deletePOTransactionRequest", "insertPOTransactionRequest",
                              "updatePurchaseOrderRequest", "updatePOTradeRequest", "updatePOTransactionRequest"]),
    ...mapActions("Location", ["getLocationsRequest"]),
    checkError2(){
      if(!this.add_transaction.itemid){
        this.errortag = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.add_transaction.itemquantity){
        this.errortag = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.add_transaction.itemprice){
        this.errortag = true;
        this.errorindex = 13;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    calculateAmount(){
      let amount = this.add_transaction.itemquantity * this.add_transaction.itemprice;
      amount = !isNaN(amount) ? amount : 0;
      let new_amount = {itemamount: amount};
      this.add_transaction = Object.assign({}, this.add_transaction, new_amount);
    },
    calculateAmountEdit(){
      let amount = this.edit_transaction.itemquantity * this.edit_transaction.itemprice;
      amount = !isNaN(amount) ? amount : 0;
      let new_amount = {itemamount: amount};
      this.edit_transaction = Object.assign({}, this.edit_transaction, new_amount);
      this.change_transaction = Object.assign({}, this.change_transaction, new_amount);
    },
    calculateTotal() {
      //this.edit_purchaseorder.purchaseordersubtotal = this.transactions.reduce((a,b) => a + (b.itemamount), 0);
      //this.edit_purchaseorder.purchaseordertotal = this.edit_purchaseorder.purchaseordersubtotal;
    },
    clearTransaction() {
      this.add_transaction={};
      this.edit_transaction={};
      this.change_transaction={};
    },
    findPriceByQuantity(pricelistid, itemid, quantity){
      let item = this.items.find(item=>item._id==itemid);
      let price = item.prices.find(price=>price.pricelistid==pricelistid && (parseInt(quantity)>=price.minqty && parseInt(quantity)<=price.maxqty));
      return price;
    },
    async insertTransaction(){
      if(!this.checkError2()) return;
      this.add_transaction.id = this.initvalue._id;
      let result = await this.insertPOTransactionRequest(this.add_transaction);
      this.transactions.push(result);
      this.isAddTransaction = false;
    },
    async uploadFile(){
      this.isUploadFile = false;
      this.upload.id = this.initvalue._id;
      this.upload.route = 'purchaseorder';
      let file = await this.insertRouteFile(this.upload);
      this.files.push(file);
      this.upload = {filename: null,file: null};
    },
    deleteTransactionDialog(item) {
      this.isDeleteTransaction = true;
      this.deletetransaction = {_id: item._id, itemname: item.itemname, itemquantity: item.itemquantity};
    },
    async deleteTransaction(item) {
      this.isDeleteTransaction = false;
      let result = await this.deletePOTransactionRequest(item._id);
      let index = this.transactions.findIndex((trans) => trans._id == result._id);
      this.transactions.splice(index, 1);
    },
    deleteFileDialog(item) {
      this.isDeleteFile = true;
      this.deletefile = {
        _id: item._id,
        filename: item.filename,
      };
      console.log(this.deletefile);
    },

    async deleteFile(payload) {
      this.isDeleteFile = false;
      let response = await this.deleteFileRequest(payload);
      let index = this.files.findIndex((trans) => trans._id == response._id);
      this.files.splice(index, 1);
    },
    onFileChange(file) {
      if (!file) {
        this.upload.file = null;
        return;
      }
      this.upload.file = file;
    },
    async updatePurchaseOrder() {
      this.change_purchaseorder._id = this.initvalue._id;
      console.log(this.change_purchaseorder)
      await this.updatePurchaseOrderRequest(this.change_purchaseorder);
      router.push("/purchaseorder/list");
    },
    updateTransactionDialog(item){
      let edit = {
        _id: item._id,
        itemid: item.itemid,
        itemimage: item.itemimage,
        itemname: item.itemname,
        itemdesc: item.itemdesc,
        itemprice: item.itemprice,
        itemquantity: item.itemquantity,
        itemamount: item.itemamount,
      }
      this.edit_transaction = Object.assign({}, edit);
      this.isEditTransaction = true;
    },
    async updateTransaction() {
      this.isEditTransaction = false;
      let response = await this.updatePOTransactionRequest(this.edit_transaction);
      let index = this.transactions.findIndex((x) => x._id == response._id);
      this.transactions.splice(index, 1, response);
      this.edit_transaction = {};
      this.getPurchaseOrderRequest(this.initvalue._id);
    },
    onChangeOrder(value, field) {
      this.change_purchaseorder[field] = value;
    },
    onChangeTransaction(value, field) {
      this.change_transaction[field] = value;
    },
    onChangePrice(){
      let update = {
        itemamount: this.add_transaction.itemprice * this.add_transaction.itemquantity,
      };
      this.add_transaction = Object.assign({}, this.add_transaction, update);
    },
    onChangePriceEdit(){
      let update = {
        itemamount: this.edit_transaction.itemprice * this.edit_transaction.itemquantity,
      };
      this.edit_transaction = Object.assign({}, this.edit_transaction, update);
    },
    selectVendor(vendorid){
      console.log('1', vendorid)
      let vendor = this.vendors.find(vendor=>vendor._id==vendorid);
      if(vendor==null) return;
      let info = {
        vendorid: vendor._id,
        purchaseordername: vendor.vendorname,
        purchaseorderaddress: vendor.vendoraddress,
        purchaseorderphone: vendor.vendorphone,
      }
      this.edit_purchaseorder = Object.assign({}, this.edit_purchaseorder, info);
      this.change_purchaseorder = Object.assign({}, this.change_purchaseorder, info);
    },
  },
  async created() {
    this.initvalue = this.$route.params;
    this.edit_purchaseorder = Object.assign({}, this.initvalue);
    if (!this.initvalue._id) this.$router.push({ name: "PurchaseOrderList" });
    this.edit_purchaseorder.purchaseorderdate = formatStdDate(this.initvalue.purchaseorderdate);
    this.transactions = this.initvalue.transactions;

    if(this.brands.length==0) await this.getBrandsRequest();
    if(this.countries.length==0) await this.getCountriesRequest();
    if(this.vendors.length==0) await this.getVendorsRequest();
    if(this.items.length==0) await this.getItemsRequest();
    if(this.prices.length==0) await this.getPricesRequest();
    if(this.pricelists.length==0) await this.getPriceListsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();


    this.calculateTotal();
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
